// Request list actions
export const LOAD_ACCOMMODATION_REQUESTS = "LOAD_ACCOMMODATION_REQUESTS";
export const LOAD_ACCOMMODATION_REQUESTS_SUCCESS = "LOAD_ACCOMMODATION_REQUESTS_SUCCESS";
export const LOAD_ACCOMMODATION_REQUESTS_ERROR = "LOAD_ACCOMMODATION_REQUESTS_ERROR";

// Request detail actions
export const LOAD_ACCOMMODATION_REQUEST_DETAIL = "LOAD_ACCOMMODATION_REQUEST_DETAIL";
export const LOAD_ACCOMMODATION_REQUEST_DETAIL_SUCCESS = "LOAD_ACCOMMODATION_REQUEST_DETAIL_SUCCESS";
export const LOAD_ACCOMMODATION_REQUEST_DETAIL_ERROR = "LOAD_ACCOMMODATION_REQUEST_DETAIL_ERROR";

// Request history actions
export const LOAD_ACCOMMODATION_REQUEST_HISTORY = "LOAD_ACCOMMODATION_REQUEST_HISTORY";
export const LOAD_ACCOMMODATION_REQUEST_HISTORY_SUCCESS = "LOAD_ACCOMMODATION_REQUEST_HISTORY_SUCCESS";
export const LOAD_ACCOMMODATION_REQUEST_HISTORY_ERROR = "LOAD_ACCOMMODATION_REQUEST_HISTORY_ERROR";

// Request plan actions
export const LOAD_ACCOMMODATION_PLAN = "LOAD_ACCOMMODATION_PLAN";
export const LOAD_ACCOMMODATION_PLAN_SUCCESS = "LOAD_ACCOMMODATION_PLAN_SUCCESS";
export const LOAD_ACCOMMODATION_PLAN_ERROR = "LOAD_ACCOMMODATION_PLAN_ERROR";

// Submit new request actions
export const SUBMIT_ACCOMMODATION_REQUEST = "SUBMIT_ACCOMMODATION_REQUEST";
export const SUBMIT_ACCOMMODATION_REQUEST_SUCCESS = "SUBMIT_ACCOMMODATION_REQUEST_SUCCESS";
export const SUBMIT_ACCOMMODATION_REQUEST_ERROR = "SUBMIT_ACCOMMODATION_REQUEST_ERROR";

// Document upload actions
export const UPLOAD_ACCOMMODATION_DOCUMENT = "UPLOAD_ACCOMMODATION_DOCUMENT";
export const UPLOAD_ACCOMMODATION_DOCUMENT_SUCCESS = "UPLOAD_ACCOMMODATION_DOCUMENT_SUCCESS";
export const UPLOAD_ACCOMMODATION_DOCUMENT_ERROR = "UPLOAD_ACCOMMODATION_DOCUMENT_ERROR";

// Download letter actions
export const DOWNLOAD_ACCOMMODATION_LETTER = "DOWNLOAD_ACCOMMODATION_LETTER";
export const DOWNLOAD_ACCOMMODATION_LETTER_SUCCESS = "DOWNLOAD_ACCOMMODATION_LETTER_SUCCESS";
export const DOWNLOAD_ACCOMMODATION_LETTER_ERROR = "DOWNLOAD_ACCOMMODATION_LETTER_ERROR";

// Config actions
export const LOAD_ACCOMMODATION_TYPES = "LOAD_ACCOMMODATION_TYPES";
export const LOAD_ACCOMMODATION_TYPES_SUCCESS = "LOAD_ACCOMMODATION_TYPES_SUCCESS";
export const LOAD_ACCOMMODATION_TYPES_ERROR = "LOAD_ACCOMMODATION_TYPES_ERROR";

// UI state actions
export const SET_ACCOMMODATION_REQUESTS_LOADING = "SET_ACCOMMODATION_REQUESTS_LOADING";
export const RESET_ACCOMMODATION_STATE = "RESET_ACCOMMODATION_STATE";
export const CLEAR_ACCOMMODATION_REQUEST_DETAIL = "CLEAR_ACCOMMODATION_REQUEST_DETAIL";
